import { createSelector } from 'reselect';

const getAjioWalletData = (
  state: import('../types/rootState').RootState
): import('../types/ajioWalletData').AjioWalletData => state.ajioWalletData;
const getAjioWalletEarnData = createSelector(
  getAjioWalletData,
  ({ ajioWalletEarnData }) => ajioWalletEarnData
);

const getAjioWalletEligibleAmount = createSelector(
  getAjioWalletEarnData,
  ajioWalletEarnData => ajioWalletEarnData?.eligibleEarnAmount || 0
);

// RONE earn from acEligibleEarn response.
const getAjioWalletRoneEligibleAmount = createSelector(
  getAjioWalletEarnData,
  ajioWalletEarnData => ajioWalletEarnData?.rOneEligibleEarnAmount || 0
);

const getAjioWalletRoneEligiblePoints = createSelector(
  getAjioWalletEarnData,
  ajioWalletEarnData => ajioWalletEarnData?.rOneEligibleEarnPoints || 0
);

const getAjioWalletStatusCode = createSelector(
  getAjioWalletEarnData,
  ajioWalletEarnData => ajioWalletEarnData?.status?.statusCode !== 2
);

const getWalletInfoValue = createSelector(
  getAjioWalletEarnData,
  ajioWalletEarnData =>
    ajioWalletEarnData?.extraResponseParams?.find(item => item?.key?.value === 'walletInfo')?.value
      .value
);

const getThresholdValue = createSelector(getAjioWalletEarnData, ajioWalletEarnData =>
  parseFloat(
    ajioWalletEarnData?.extraResponseParams?.find(
      item => item?.key?.value === 'minimumEarnThreshold'
    )?.value?.value || ''
  )
);

export {
  getAjioWalletStatusCode,
  getWalletInfoValue,
  getThresholdValue,
  getAjioWalletEligibleAmount,
  getAjioWalletRoneEligibleAmount,
  getAjioWalletRoneEligiblePoints
};
